import React, { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { GetFastChatIdResponse } from '@dreamai/types';
import { useLinkedThreads } from '../../contexts/LinkedThreadsContext';
import api from '../../api';
import './fast-chat-button.scss';

const FastChatButton: React.FC = () => {
  const { getAccessTokenSilently } = useAuth0();
  const { openThread } = useLinkedThreads();
  const [loading, setLoading] = useState(true);
  const [threadId, setThreadId] = useState<string | null>(null);
  const [agentId, setAgentId] = useState<string | null>(null);

  useEffect(() => {
    const fetchFastChatId = async () => {
      try {
        const token = await getAccessTokenSilently();
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const response = await api.get<GetFastChatIdResponse>(
          '/agents/fast-chat-id',
        );

        if (
          response.data.success &&
          response.data.threadId &&
          response.data.agentId
        ) {
          setThreadId(response.data.threadId);
          setAgentId(response.data.agentId);
        }
      } catch (error) {
        console.error('Error fetching fast chat ID:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchFastChatId();
  }, [getAccessTokenSilently]);

  const handleClick = () => {
    if (threadId && agentId) {
      openThread(threadId, 'fast-chat', {}, agentId);
    }
  };

  // Show nothing while loading
  if (loading) {
    return null;
  }

  // Show nothing if we failed to load
  if (!threadId || !agentId) {
    return null;
  }

  return (
    <button
      className='fast-chat-button'
      onClick={handleClick}
      title='Open Fast Chat'
    >
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
      >
        <path
          d='M13 2L4.09344 12.6879C3.74463 13.1064 3.57023 13.3157 3.56756 13.4925C3.56524 13.6461 3.63372 13.7923 3.75324 13.8889C3.89073 14 4.16316 14 4.70802 14H12L11 22L19.9065 11.3121C20.2553 10.8936 20.4297 10.6843 20.4324 10.5075C20.4347 10.3539 20.3663 10.2077 20.2467 10.1111C20.1092 10 19.8368 10 19.292 10H12L13 2Z'
          stroke='#FFD601'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </button>
  );
};

export default FastChatButton;
